<template
    ><v-dialog v-model="loading" persistent>
        <v-overlay :value="loading">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-overlay>
    </v-dialog>
</template>
<script>
import { mapState } from 'vuex';

export default {
    name: 'Loader',
    computed: {
        ...mapState('loader', ['loading'])
    }
};
</script>

<style scoped></style>
